import { render, staticRenderFns } from "./pay.vue?vue&type=template&id=7f6c5aea&scoped=true"
import script from "./pay.js?vue&type=script&lang=js&external"
export * from "./pay.js?vue&type=script&lang=js&external"
import style0 from "./pay.scss?vue&type=style&index=0&id=7f6c5aea&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6c5aea",
  null
  
)

export default component.exports